import { useEffect, useState } from "react";
import Quizz from "../../components/Quizz/Quizz";
import BasicPage from "../../components/baseComponents/basicPage/BasicPage";
import { makeGETRequest } from "../../request/rawRequest";

import { titleSection } from "../../components/Video/Video";
import jsonQuestion from "./quizzExemple.json";

interface Skill {
  _id: string;
  name: string;
  quizz?: any;
}

const FormalPratiqueSkill: React.FC = () => {
  const ids =
    window.location.pathname.split("/formalPratique/")[1].split("/") ?? "";
  const skillID = ids[0] ?? "";

  const [skill, setSkill] = useState<Skill>();

  const exempleQuizz = jsonQuestion;

  useEffect(() => {
    makeGETRequest("/skills/videotutorial/unique/id?_id=" + skillID).then(
      (res) => {
        const { _id, name, quizz } = res;
        setSkill({
          _id,
          name,
          quizz,
        });
      }
    );
  }, []);

  return (
    <BasicPage
      pathLogo={""}
      subtitle=""
      title={skill?.name ?? ""}
      pathReturn="welcome"
    >
      {titleSection("1 Les quiz :", " teste tes connaissances")}
      <Quizz questions={skill?.quizz} _id={skillID.toString()} />

      <div
        style={{
          marginBottom: 100,
        }}
      ></div>
    </BasicPage>
  );
};

export default FormalPratiqueSkill;
